import { useOutletContext } from 'react-router-dom'

function Docs(){
	const { translate } = useOutletContext()
	return <h1 style={{"marginTop":"75px"}}>{translate('docs-header')}</h1>
}

export default Docs